<div class="action-point-picker-container flex flex-col">
  <app-table-search-input
    class="block mb-2"
    (searchDataEvent)="searchValue.set($event);"
    inputWidth="100%"
    placeholder="Device Name, type & other"
  />
  <div class="point-list gap-2 flex flex-wrap">
    @for (point of filteredActionPointsList(); track point.id) {
      <button
        class="px-4 py-2 border rounded-lg border-ui-gray-100 flex items-center justify-between whitespace-nowrap text-ui-gray-100"
        (click)="selectActionPoint(point)"
        [class.bg-ui-gray-100]="point.deviceActionPointsId === selectedPoint()"
        [class.text-white]="point.deviceActionPointsId === selectedPoint()"
      >
        {{ point.name }}
        @if (point.deviceActionPointsId === selectedPoint()) {
          <mat-icon
            class="mx-2"
            fontIcon="check"
          />
        }
      </button>
    }
  </div>
</div>
